import React, { useState } from "react";
import "@assets/css/common/style_calendar.css";

const Calendar = ({ onDateSelect, onClose, position, show = true }) => {
    const [currentDate, setCurrentDate] = useState(new Date());
    const [selectedStartDate, setSelectedStartDate] = useState(null);
    const [selectedEndDate, setSelectedEndDate] = useState(null);
    const [tempStartDate, setTempStartDate] = useState(null);
    const [tempEndDate, setTempEndDate] = useState(null);

    const getDaysInMonth = (date) => {
        const year = date.getFullYear();
        const month = date.getMonth();
        const firstDay = new Date(year, month, 1);
        const lastDay = new Date(year, month + 1, 0);
        const daysInMonth = lastDay.getDate();
        const startingDay = firstDay.getDay();

        const days = [];
        // 이전 달의 날짜들
        for (let i = 0; i < startingDay; i++) {
            const prevDate = new Date(year, month, -startingDay + i + 1);
            days.push({ date: prevDate, isOtherMonth: true });
        }
        // 현재 달의 날짜들
        for (let i = 1; i <= daysInMonth; i++) {
            days.push({ date: new Date(year, month, i), isOtherMonth: false });
        }
        // 다음 달의 날짜들
        const remainingDays = 42 - days.length; // 6주 = 42일
        for (let i = 1; i <= remainingDays; i++) {
            const nextDate = new Date(year, month + 1, i);
            days.push({ date: nextDate, isOtherMonth: true });
        }

        return days;
    };

    const handleDateClick = (date, isOtherMonth) => {
        if (isOtherMonth) return;

        // 단일 날짜 선택 모드로 변경
        setSelectedStartDate(date);
        setSelectedEndDate(null); // 범위 선택 모드가 아니므로 종료일은 null
        setTempStartDate(date);
        setTempEndDate(null);

        // 바로 선택된 날짜 적용
        if (onDateSelect) {
            onDateSelect(date, null);
        }
        if (onClose) {
            onClose();
        }
    };

    const isSameDate = (date1, date2) => {
        if (!date1 || !date2) return false;
        return (
            date1.getDate() === date2.getDate() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getFullYear() === date2.getFullYear()
        );
    };

    const isInRange = (date) => {
        if (!tempStartDate || !tempEndDate) return false;
        return date > tempStartDate && date < tempEndDate;
    };

    const handlePrevMonth = () => {
        setCurrentDate(
            new Date(currentDate.getFullYear(), currentDate.getMonth() - 1)
        );
    };

    const handleNextMonth = () => {
        setCurrentDate(
            new Date(currentDate.getFullYear(), currentDate.getMonth() + 1)
        );
    };

    const handleApply = () => {
        if (selectedStartDate && selectedEndDate) {
            onDateSelect(selectedStartDate, selectedEndDate);
            onClose();
        }
    };

    const handleCancel = () => {
        onClose();
    };

    const days = getDaysInMonth(currentDate);
    const weekDays = ["일", "월", "화", "수", "목", "금", "토"];

    return (
        <div
            className="calendar-popup"
            style={{
                display: "block",
                position: "absolute",
                top: position?.top || "0",
                left: position?.left || "0",
                width: '300px',
                backgroundColor: '#fff',
                borderRadius: '8px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                zIndex: 10001,
                padding: '15px'
            }}
        >
            <div className="calendar-header">
                <button className="calendar-nav-btn" onClick={handlePrevMonth}>
                    &lt;
                </button>
                <div className="calendar-title">
                    {currentDate.getFullYear()}년 {currentDate.getMonth() + 1}월
                </div>
                <button className="calendar-nav-btn" onClick={handleNextMonth}>
                    &gt;
                </button>
            </div>
            <div className="calendar-weekdays">
                {weekDays.map((day) => (
                    <div key={day}>{day}</div>
                ))}
            </div>
            <div className="calendar-days">
                {days.map(({ date, isOtherMonth }, index) => {
                    const isToday = isSameDate(date, new Date());
                    const isSelectedStart = isSameDate(date, tempStartDate);
                    const isSelectedEnd = isSameDate(date, tempEndDate);
                    const isInDateRange = isInRange(date);

                    return (
                        <div
                            key={index}
                            className={`calendar-day ${isOtherMonth ? "other-month" : ""} 
                         ${isToday ? "today" : ""} 
                         ${isSelectedStart ? "selected-start" : ""} 
                         ${isSelectedEnd ? "selected-end" : ""} 
                         ${isInDateRange ? "in-range" : ""}`}
                            onClick={() => handleDateClick(date, isOtherMonth)}
                        >
                            {date.getDate()}
                        </div>
                    );
                })}
            </div>
            <div className="calendar-footer">
                <button
                    className="calendar-btn calendar-btn-cancel"
                    onClick={handleCancel}
                >
                    취소
                </button>
                <button
                    className="calendar-btn calendar-btn-apply"
                    onClick={handleApply}
                >
                    적용
                </button>
            </div>
        </div>
    );
};

export default Calendar;
